<template>
   <div class="app-release">
        <el-card shadow="never">
	        <div slot="header" class="clearfix">
	            <span>
	                任务流 - 
	                
	                <span v-if="workflowDetail.status == $root.ApplyStatusIng" class="app-color-info">{{ $t('ongoing') }}</span>
	                <span v-if="workflowDetail.status == $root.ApplyStatusSuccess" class="app-color-success">{{ $t('finished') }}</span>
	                
	            </span>
	        </div>

	        <!-- apply -->
	        <el-row :gutter="20">
	            
	            <el-col :span="10">
	                <span class="sp-title">{{ $t('name') }}:</span>
	                <span>{{ workflowDetail.name }}</span>
	            </el-col>

	            <el-col :span="14">
	                <span class="sp-title">{{ $t('project_space_name') }}:</span>
	                <span>{{ workflowDetail.space_name }} </span>
	                <el-tooltip effect="dark" :content="$t('belong_to_space') + ': ' + this.workflowDetail.space_name" placement="top">
	                        <span class="app-cursor"><i class="iconfont icon-space"></i></span>
	                </el-tooltip>
	            </el-col>
	        </el-row>

	        <el-row class="app-mt-20" :gutter="20">
	            <el-col :span="10">
                	<span class="sp-title">{{ $t('description') }}:</span>
	            	<span>{{ workflowDetail.description }} </span>
	            </el-col>
	            <el-col :span="14">
	                <span class="sp-title">{{ $t('submit_time') }}:</span>
	            	<span>{{ $root.FormatDateTime(this.workflowDetail.ctime) }} </span>
	            	
	            </el-col>
	        </el-row>
    
            <el-divider></el-divider>

	        <div class="clearfix">
            
                 <el-button v-if="$root.CheckPriv($root.Priv.DEPLOY_APPLY)" 
                 @click="openDepApplyDialogHandler" type="primary" plain :disabled="workflowDetail.status ==$root.ApplyStatusSuccess ||workflowDetail.status ==$root.ApplyStatusDrop">创建部署任务</el-button>  
	        	 
                 <el-button v-if="$root.CheckPriv($root.Priv.COMMAND_OPERATE_NEW)" 
                 @click="openCmdApllyDialogHandler" type="primary" plain :disabled="workflowDetail.status ==$root.ApplyStatusSuccess ||workflowDetail.status ==$root.ApplyStatusDrop">创建命令任务</el-button>
	        	 
                 <el-button v-if="$root.CheckPriv($root.Priv.WORKFLOW_ONEKEY_AUDIT)" 
                 @click="openOnekeyAuditDialogHandler" type="primary" plain :disabled="workflowDetail.status ==$root.ApplyStatusSuccess ||workflowDetail.status ==$root.ApplyStatusDrop">一键审核</el-button>
            
                 <el-button v-if="$root.CheckPriv($root.Priv.WORKFLOW_FINISH)" 
                 @click="finishWorkFlowSubmitHandler" type="warning" plain  :disabled="workflowDetail.status ==$root.ApplyStatusSuccess ||workflowDetail.status ==$root.ApplyStatusDrop">结束任务流</el-button>
            
            </div>
	
	        <el-divider></el-divider>


	        <template>
			  <el-table
			    :data="tableData"
			    style="width: 100%"
                :default-sort = "{prop: 'ctime', order: 'ascending'}">

			    <el-table-column
			      prop="id"
			      label="ID"
			      width="100"
                  sortable>
			    </el-table-column>

			    <el-table-column
			      prop="name"
			      label="名称">
			    </el-table-column>


			    <el-table-column
			      prop="template"
			      label="模板" >
			    </el-table-column>

			    <el-table-column prop="flow_type" label="任务类型" width="100">
                   <template slot-scope="scope">
				      <el-tag
					    :key="scope.row.flow_type.label"
					    :type="scope.row.flow_type.type"
					    effect="dark">
					    {{ scope.row.flow_type.label }}
					  </el-tag>
					</template>
			    </el-table-column>

			    <el-table-column prop="submiter" width="100" :label="$t('submiter')">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="scope.row.email" placement="top">
                            <span class="app-cursor">{{ scope.row.username }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>

				
			    <el-table-column prop="ctime" width="100" :label="$t('submit_time')" sortable>
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" :content="$root.FormatDateTime(scope.row.ctime)" placement="top">
                            <span class="app-cursor">{{ $root.FormatDateFromNow(scope.row.ctime) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <el-table-column prop="audit_status" width="100" :label="$t('audit')">
                    <template slot-scope="scope">
                        <span class="app-color-warning" v-if="scope.row.audit_status == $root.AuditStatusPending">{{ $t('unaudit') }}</span>
                        <span class="app-color-success" v-else-if="scope.row.audit_status == $root.AuditStatusOk">{{ $t('pass') }}</span>
                        <span class="app-color-error" v-else-if="scope.row.audit_status == $root.AuditStatusRefuse">{{ $t('denied') }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>

                <el-table-column prop="status" width="100" :label="$t('status')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == $root.ApplyStatusNone"><i class="iconfont small left icon-wait"></i>{{ $t('wait_online') }}</span>
                        <span v-else-if="scope.row.status == $root.ApplyStatusIng"><i class="iconfont small left icon-coffee"></i>{{ $t('onlineing') }}</span>
                        <span class="app-color-success" v-else-if="scope.row.status == $root.ApplyStatusSuccess"><i class="iconfont small left icon-success"></i>{{ $t('success') }}</span>
                        <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusFailed"><i class="iconfont small left icon-failed"></i>{{ $t('failed') }}</span>
                        <span class="app-color-gray" v-else-if="scope.row.status == $root.ApplyStatusDrop"><i class="iconfont small left icon-drop"></i>{{ $t('drop') }}</span>
                        <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusRollback"><i class="iconfont small left icon-rollback"></i>{{ $t('rollback') }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('operate')" width="100" align="right">
                    <template slot-scope="scope">
                        <el-dropdown trigger="click" @command="flowHandler($event, scope.row)">
                            
                            <el-button size="small">
                                {{ $t('operate') }}<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>

                            <el-dropdown-menu class="app-op-dropdown" slot="dropdown">
                                <el-dropdown-item command="view" v-if="(scope.row.flow_type.typeid==2 && $root.CheckPriv($root.Priv.COMMAND_OPERATE_VIEW)) ||(scope.row.flow_type.typeid==1 && $root.CheckPriv($root.Priv.DEPLOY_VIEW)) ">
                                    <i class="iconfont left small icon-view"></i>{{ $t('view') }}
                                </el-dropdown-item>

                                <el-dropdown-item command="edit" 
                                v-if="scope.row.status == $root.ApplyStatusNone && (scope.row.audit_status == $root.AuditStatusPending || scope.row.audit_status == $root.AuditStatusRefuse) && ((scope.row.flow_type.typeid == 2 && $root.CheckPriv($root.Priv.COMMAND_OPERATE_EDIT)) || (scope.row.flow_type.typeid == 1 && $root.CheckPriv($root.Priv.DEPLOY_EDIT)))">
                                    <i class="iconfont left small icon-edit"></i>{{ $t('edit') }}
                                </el-dropdown-item>
                                
                                <el-dropdown-item command="audit"
                                v-if="scope.row.audit_status == $root.AuditStatusPending && scope.row.status == $root.ApplyStatusNone && ((scope.row.flow_type.typeid == 2 && $root.CheckPriv($root.Priv.COMMAND_OPERATE_AUDIT)) ||(scope.row.flow_type.typeid == 1 && $root.CheckPriv($root.Priv.DEPLOY_AUDIT)))">
                                    <i class="iconfont left small icon-audit"></i>{{ $t('audit') }}
                                </el-dropdown-item>
                                
                                <el-dropdown-item command="execute"
                                v-if="scope.row.audit_status == $root.AuditStatusOk && (scope.row.status == $root.ApplyStatusNone || scope.row.status == $root.ApplyStatusIng || scope.row.status == $root.ApplyStatusSuccess || scope.row.status == $root.ApplyStatusFailed || scope.row.status == $root.ApplyStatusRollback) && ((scope.row.flow_type.typeid ==2 && $root.CheckPriv($root.Priv.COMMAND_OPERATE_EXECUTE)) ||(scope.row.flow_type.typeid ==1 && $root.CheckPriv($root.Priv.DEPLOY_DEPLOY)))">
                                    <i class="iconfont left small icon-coffee"></i>{{ $t('online') }}
                                </el-dropdown-item>
                                
                                <el-dropdown-item command="drop"
                                v-if="scope.row.status != $root.ApplyStatusIng && scope.row.status != $root.ApplyStatusDrop && ((scope.row.flow_type.typeid == 2 && $root.CheckPriv($root.Priv.COMMAND_OPERATE_DROP)) ||(scope.row.flow_type.typeid == 1 && $root.CheckPriv($root.Priv.DEPLOY_DROP)))">
                                    <i class="iconfont left small icon-drop"></i>{{ $t('drop') }}
                                </el-dropdown-item>
                           
                            </el-dropdown-menu>

                        </el-dropdown>
                    </template>
                </el-table-column>

			  </el-table>
			</template>
  
	    </el-card>


	    <!-- 查看模态框 -->
        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="dialogTitle"
        :visible.sync="dialogCmdVisible"
        @close="closeCmdDialogHandler">
            <div class="app-dialog" v-loading="dialogCmdLoading">
                <el-form size="medium" label-width="120px">
                    <el-form-item :label="$t('space_name')">
                        {{ dialogCmdDetail.space_name }}
                    </el-form-item>
                    <el-form-item :label="$t('command_template_name')">
                        {{ dialogCmdDetail.template_name }}
                    </el-form-item>
                    <el-form-item :label="$t('command_name')">
                        {{ dialogCmdDetail.name }}
                    </el-form-item>
                    <el-form-item :label="$t('command_mode')">
                        <div v-if="dialogCmdDetail.tmode == 1">
                            <i class="iconfont icon-branch"></i> {{ this.$t('tpl_mode') }}
                        </div>
                        <div v-else>
                            <i class="iconfont icon-tag"></i> {{ this.$t('flow_mode') }}
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('command_illustrate')">
                        {{ dialogCmdDetail.description }}
                    </el-form-item>
                    <el-form-item :label="$t('audit_status')">
                        {{ this.auditCmdStatusTitle(dialogCmdDetail.audit_status) }}
                    </el-form-item>
                    <el-form-item :label="$t('submiter')">
                        {{ dialogCmdDetail.username }} - {{ dialogCmdDetail.email }}
                    </el-form-item>
                    <el-form-item :label="$t('submit_time')">
                        {{ this.$root.FormatDateTime(dialogCmdDetail.ctime) }}
                    </el-form-item>

                    <template v-if="dialogCmdDetail.cmd == 'audit'">
                        <el-form-item :label="$t('audit')" v-if="dialogCmdDetail.status == $root.ApplyStatusNone && dialogCmdDetail.audit_status == $root.AuditStatusPending">
                            <div>
                                <el-radio v-model="auditStatus" :label="$root.AuditStatusOk"><span class="app-color-success">{{ $t('audit_pass') }}</span></el-radio>
                                <el-radio v-model="auditStatus" :label="$root.AuditStatusRefuse"><span class="app-color-error">{{ $t('audit_denied') }}</span></el-radio>
                            </div>
                        </el-form-item>
                        <el-form-item :label="$t('deined_reason')" v-if="dialogCmdDetail.status == $root.ApplyStatusNone && dialogCmdDetail.audit_status == $root.AuditStatusPending && auditStatus == $root.AuditStatusRefuse">
                            <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="auditRefusalReason"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="dialogCmdSubmitAuditStatusHandler">{{ $t('audit') }}</el-button>
                            <el-button size="small" @click="closeCmdDialogHandler">{{ $t('close') }}</el-button>
                        </el-form-item>
                    </template>  
                </el-form>
            </div>
        </el-dialog>

        <!-- 编辑模态框 -->
        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="dialogTitle"
        :visible.sync="dialogCmdEditVisible"
        @close="closeCmdEditDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form 
                class="app-form" 
                ref="dialogCmdEditRef" 
                :model="dialogCmdForm" 
                size="medium" 
                label-width="130px">
                    <el-form-item
                    :label="$t('command_template_name')">
                        {{ dialogCmdForm.template_name }}
                    </el-form-item>
                    <el-form-item 
                    :label="$t('command_name')">
                        {{ dialogCmdForm.name}}
                    </el-form-item>
                    <el-form-item :label="$t('command_mode')">
                        <span v-if="dialogCmdForm.tmode == 1">
                            <i class="iconfont icon-branch"></i> - {{ $t('tpl_mode') }}
                        </span>
                        <span v-if="dialogCmdForm.tmode == 2">
                            <i class="iconfont icon-tag"></i> {{ $t('flow_mode') }}
                        </span>
                    </el-form-item>

                    <el-form-item 
                    :label="$t('command_illustrate')"
                    prop="description"
                    :rules="[
                        { required: true, message: $t('command_illustrate_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :rows="4" type="textarea" :placeholder="$t('please_input_command_illustrate')" v-model="dialogCmdForm.description" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeCmdEditDialogHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="dialogBtnLoading" size="small" type="primary" @click="dialogCmdSubmitEditHandler">{{ $t('enter') }}</el-button>
                </div>
            </div>
        </el-dialog>



        <!-- 部署查看  -->
		<el-dialog
        :width="$root.DialogNormalWidth"
        :title="dialogTitle"
        :visible.sync="dialogDepVisible"
        @close="closeCmdDialogHandler">
            <div class="app-dialog" v-loading="dialogDepLoading">
                <el-form size="medium" label-width="120px">
                    <el-form-item :label="$t('space_name')">
                        {{ dialogDepDetail.space_name }}
                    </el-form-item>
                    <el-form-item :label="$t('project_name')">
                        {{ dialogDepDetail.project_name }}
                    </el-form-item>
                    <el-form-item :label="$t('apply_order')">
                        {{ dialogDepDetail.name }}
                    </el-form-item>
                    <el-form-item :label="$t('deploy_mode')">
                        <div v-if="dialogDepDetail.deploy_mode == 1">
                            <i class="iconfont icon-branch"></i> {{ this.$t('branch_deploy') }} - {{ $t('branch_name') }}: {{ dialogDepDetail.branch_name }} - {{ $t('version') }}: {{ dialogDepDetail.commit_version ? dialogDepDetail.commit_version :  'HEAD'}}
                        </div>
                        <div v-else>
                            <i class="iconfont icon-tag"></i> {{ this.$t('tag_deploy') }} - {{ dialogDepDetail.branch_name }}
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('deploy_illustrate')">
                        {{ dialogDepDetail.description }}
                    </el-form-item>
                    <el-form-item :label="$t('audit_status')">
                        {{ this.auditStatusTitle(dialogDepDetail.audit_status) }}
                    </el-form-item>
                    <el-form-item :label="$t('submiter')">
                        {{ dialogDepDetail.username }} - {{ dialogDepDetail.email }}
                    </el-form-item>
                    <el-form-item :label="$t('submit_time')">
                        {{ this.$root.FormatDateTime(dialogDepDetail.ctime) }}
                    </el-form-item>
                    <template v-if="dialogDepDetail.cmd == 'audit'">
                        <el-form-item :label="$t('audit')" v-if="dialogDepDetail.status == $root.ApplyStatusNone && dialogDepDetail.audit_status == $root.AuditStatusPending">
                            <div>
                                <el-radio v-model="auditStatus" :label="$root.AuditStatusOk"><span class="app-color-success">{{ $t('audit_pass') }}</span></el-radio>
                                <el-radio v-model="auditStatus" :label="$root.AuditStatusRefuse"><span class="app-color-error">{{ $t('audit_denied') }}</span></el-radio>
                            </div>
                        </el-form-item>
                        <el-form-item :label="$t('deined_reason')" v-if="dialogDepDetail.status == $root.ApplyStatusNone && dialogDepDetail.audit_status == $root.AuditStatusPending && auditStatus == $root.AuditStatusRefuse">
                            <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="auditRefusalReason"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="dialogDepSubmitAuditStatusHandler">{{ $t('audit') }}</el-button>
                            <el-button size="small" @click="closeDepDialogHandler">{{ $t('close') }}</el-button>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
        </el-dialog>

        <!-- 部署编辑-->
        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="$t('edit_apply_order')"
        :visible.sync="dialogDepEditVisible"
        @close="closeDepEditDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form 
                class="app-form" 
                ref="dialogDepEditRef" 
                :model="dialogDepForm" 
                size="medium" 
                label-width="130px">
                    <el-form-item
                    :label="$t('project_name')">
                        {{ dialogDepDetail.project_name }}
                    </el-form-item>
                    <el-form-item 
                    :label="$t('apply_name')">
                        {{ dialogDepDetail.name}}
                    </el-form-item>
                    <el-form-item :label="$t('deploy_mode')">
                        <span v-if="dialogDepDetail.deploy_mode == $root.DeployModeBranch">
                            <i class="iconfont icon-branch"></i> - {{ $t('branch_deploy') }}<template v-if="dialogDepDetail.repo_branch"> - <strong>{{ dialogDepDetail.repo_branch }}</strong> {{ $t('branch') }}</template>
                        </span>
                        <span v-if="dialogDepDetail.deploy_mode == $root.DeployModelTag">
                            <i class="iconfont icon-tag"></i> {{ $t('tag_deploy') }}
                        </span>
                    </el-form-item>

                    <el-form-item 
                    v-if="dialogDepDetail.deploy_mode == $root.DeployModelTag"
                    :label="$t('tag_name')"
                    prop="branch_name"
                    :rules="[
                        { required: true, message: $t('tag_name_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input class="app-input-mini" :placeholder="$t('please_input_tag_name')" v-model="dialogDepForm.branch_name" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item 
                    v-if="dialogDepDetail.deploy_mode == $root.DeployModeBranch && dialogDepDetail.repo_branch == ''"
                    :label="$t('branch_name')"
                    prop="branch_name"
                    :rules="[
                        { required: true, message: $t('branch_name_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input class="app-input-mini" :placeholder="$t('please_input_branch_name')" v-model="dialogDepForm.branch_name" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item 
                    v-if="dialogDepDetail.deploy_mode == $root.DeployModeBranch"
                    :label="$t('commit_version')"
                    prop="commit_version">
                        <el-input class="app-input-normal" :placeholder="$t('please_input_commit_version')" v-model="dialogDepForm.commit_version" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item 
                    :label="$t('deploy_illustrate')"
                    prop="description"
                    :rules="[
                        { required: true, message: $t('deploy_illustrate_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :rows="4" type="textarea" :placeholder="$t('please_input_deploy_illustrate')" v-model="dialogDepForm.description" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeDepEditDialogHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="dialogBtnLoading" size="small" type="primary" @click="dialogDepSubmitEditHandler">{{ $t('enter') }}</el-button>
                </div>
            </div>
        </el-dialog>


        <!-- 命令申请 -->
        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="$t('input_deploy_apply')"
        :visible.sync="dialogCmdApplyVisible"
        @close="closeCmdApplyDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form class="app-form" ref="dialogCmdRef" :model="dialogCmdApplyForm" size="medium" label-width="130px">
                   
                    <el-form-item 
		                :label="$t('select_template')"
		                prop="template_id"
		                :rules="[
		                    { required: true, message: $t('template_cannot_empty'), trigger: 'blur'},
		                ]">
		                    <el-select 
		                    v-model="dialogCmdApplyForm.template_id" 
		                    filterable 
		                    :placeholder="$t('please_input_keyword')">
		                        <el-option
		                        v-for="proj in templateList"
		                        :key="proj.id"
		                        :label="proj.name"
		                        :value="proj.id">
		                        </el-option>
		                    </el-select>
		            </el-form-item>

               
                    <el-form-item 
                    :label="$t('command_name')"
                    prop="name"
                    :rules="[
                        { required: true, message: $t('name_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :placeholder="$t('please_input_name')" v-model="dialogCmdApplyForm.name" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('command_mode')">
                        <span v-if="dialogCmdApplyForm.tmode == 1">
                            <i class="iconfont icon-tag"></i> - {{ $t('tpl_mode') }}
                            <template v-if="dialogCmdApplyForm.tmode==2"> - <strong>{{ templateDetail.id }}</strong> {{ $t('flow_mode') }}</template>
                        </span>
                        <span v-if="dialogCmdApplyForm.tmode == 2">
                            <i class="iconfont icon-tag"></i> {{ $t('tag_deploy') }}
                        </span>
                    </el-form-item>

                 
                    <el-form-item 
                    :label="$t('command_illustrate')"
                    prop="description"
                    :rules="[
                        { required: true, message: $t('command_illustrate_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :rows="4" type="textarea" :placeholder="$t('please_input_command_illustrate')" v-model="dialogCmdApplyForm.description" autocomplete="off"></el-input>
                    </el-form-item>

                    
                 </el-form>
                 <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeCmdApplyDialogHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="btnLoading" size="small" type="primary" @click="dialogCmdApplySubmitHandler">{{ $t('enter') }}</el-button>
                </div>
            </div>
        </el-dialog>


        <!-- 部署申请 -->
        <el-dialog
        :width="$root.DialogNormalWidth"
        :title="$t('input_deploy_apply')"
        :visible.sync="dialogDepApplyVisible"
        @close="closeDepApplyDialogHandler">
            <div class="app-dialog" v-loading="dialogLoading">
                <el-form class="app-form" ref="formDeployRef" :model="dialogDepApplyForm" size="medium" label-width="130px">
                    
                <el-form-item 
                :label="$t('select_project')"
                prop="project_id"
                :rules="[
                    { required: true, message: $t('project_cannot_empty'), trigger: 'blur'},
                ]">
                    <el-select 
                    v-model="dialogDepApplyForm.project_id" 
                    @change="loadProjectDetail"
                    filterable 
                    :placeholder="$t('please_input_keyword')">
                        <el-option
                        v-for="proj in projectList"
                        :key="proj.id"
                        :label="proj.name"
                        :value="proj.id">
                        </el-option>
                    </el-select>
                </el-form-item>


                    <el-form-item 
                    :label="$t('apply_name')"
                    prop="name"
                    :rules="[
                        { required: true, message: $t('name_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :placeholder="$t('please_input_apply_name')" v-model="dialogDepApplyForm.name" autocomplete="off"></el-input>
                    </el-form-item>


                    <el-form-item :label="$t('deploy_mode')">
                        <span v-if="projectDetail.deploy_mode == 1">
                            <i class="iconfont icon-branch"></i> - {{ $t('branch_deploy') }}<template v-if="projectDetail.repo_branch"> - <strong>{{ projectDetail.repo_branch }}</strong> {{ $t('branch') }}</template>
                        </span>
                        <span v-if="projectDetail.deploy_mode == 2">
                            <i class="iconfont icon-tag"></i> {{ $t('tag_deploy') }}
                        </span>
                    </el-form-item>

                    <el-form-item 
                    v-if="projectDetail.deploy_mode == 2"
                    :label="$t('tag_name')"
                    prop="branch_name"
                    :rules="[
                        { required: true, message: $t('tag_name_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input class="app-input-mini" :placeholder="$t('please_input_tag_name')" v-model="dialogDepApplyForm.branch_name" autocomplete="off"></el-input>
                    </el-form-item>


                    <el-form-item 
                    v-if="projectDetail.deploy_mode == 1 && projectDetail.repo_branch == ''"
                    :label="$t('branch_name')"
                    prop="branch_name"
                    :rules="[
                        { required: true, message: $t('branch_name_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input class="app-input-mini" :placeholder="$t('please_input_branch_name')" v-model="dialogDepApplyForm.branch_name" autocomplete="off"></el-input>
                    </el-form-item>


                    <el-form-item 
                    v-if="projectDetail.deploy_mode == 1"
                    :label="$t('commit_version')"
                    prop="commit_version">
                        <el-input class="app-input-normal" :placeholder="$t('please_input_commit_version')" v-model="dialogDepApplyForm.commit_version" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item 
                    :label="$t('deploy_illustrate')"
                    prop="description"
                    :rules="[
                        { required: true, message: $t('deploy_illustrate_cannot_empty'), trigger: 'blur'},
                    ]">
                        <el-input :rows="4" type="textarea" :placeholder="$t('please_input_deploy_illustrate')" v-model="dialogDepApplyForm.description" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item
                    :label="$t('rollback_apply')"
                    prop="rollback_id">
                        <el-select 
                        v-model="dialogDepApplyForm.rollback_id" 
                        filterable 
                        style="width: 100%;"
                        :placeholder="$t('please_input_keyword')">
                            <el-option
                            v-for="r in rollbackList"
                            :key="r.id"
                            :label="'(ID:' + r.id + ') ' + r.name"
                            :value="r.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                 </el-form>

                 <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="closeDepApplyDialogHandler">{{ $t('cancel') }}</el-button>
                    <el-button :loading="btnLoading" size="small" type="primary" @click="dialogDepApplySubmitHandler">{{ $t('enter') }}</el-button>
                 </div>

            </div>
        </el-dialog>


        <!-- 一键审核 -->
        <el-dialog :width="$root.DialogNormalWidth"
        :title="$t('onekey_audit')"
        :visible.sync="dialogOnekeyAuditVisible"
        @close="closeOnekeyAuditDialogHandler">

            <el-table :data="gridData" size="small" :empty-text="$t('no_need_onekey_audit')" >

                <el-table-column width="50" property="id" label="ID"></el-table-column>
                <el-table-column property="name" label="名称"></el-table-column>
                <el-table-column property="template" label="模板名"></el-table-column>
                <el-table-column width="80" property="status" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == $root.ApplyStatusNone"><i class="iconfont small left icon-wait"></i>{{ $t('wait_online') }}</span>
                        <span v-else-if="scope.row.status == $root.ApplyStatusIng"><i class="iconfont small left icon-coffee"></i>{{ $t('onlineing') }}</span>
                        <span class="app-color-success" v-else-if="scope.row.status == $root.ApplyStatusSuccess"><i class="iconfont small left icon-success"></i>{{ $t('success') }}</span>
                        <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusFailed"><i class="iconfont small left icon-failed"></i>{{ $t('failed') }}</span>
                        <span class="app-color-gray" v-else-if="scope.row.status == $root.ApplyStatusDrop"><i class="iconfont small left icon-drop"></i>{{ $t('drop') }}</span>
                        <span class="app-color-error" v-else-if="scope.row.status == $root.ApplyStatusRollback"><i class="iconfont small left icon-rollback"></i>{{ $t('rollback') }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>


            <el-form>
                <el-form-item :label="$t('audit')" v-if="gridDataTotal > 0" >
                    <div>
                        <el-radio v-model="auditStatus" :label="$root.AuditStatusOk"><span class="app-color-success">{{ $t('audit_pass') }}</span></el-radio>
                        <el-radio v-model="auditStatus" :label="$root.AuditStatusRefuse"><span class="app-color-error">{{ $t('audit_denied') }}</span></el-radio>
                    </div>
                </el-form-item>

                <el-form-item :label="$t('deined_reason')" v-if="gridDataTotal > 0 && auditStatus == $root.AuditStatusRefuse">
                    <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="auditRefusalReason"></el-input>
                </el-form-item>
                
                <el-form-item>
                    <el-button v-if="gridDataTotal > 0" size="small" type="primary" @click="dialogOnekeyAuditSubmitHandler">{{ $t('audit') }}</el-button>
                    <el-button size="small" @click="closeOnekeyAuditDialogHandler">{{ $t('close') }}</el-button>
                </el-form-item>
            </el-form>
            
        </el-dialog>

       
    </div>
</template>





<script>
import {
    OperateListApi, 
    OperateUpdateApi, 
    OperateDeleteApi, 
    TemplateAllApi,
    OperateDetailApi,
    OperateDropApi,
    OperateAuditStatusUpdateApi,
    TemplateListApi
} from '@/api/command.js'

import { 
    applyProjectAllApi, 
    applyListApi, 
    applyDetailApi, 
    applyProjectDetailApi, 
    applyAuditApi, 
    applyUpdateApi, 
    applyDropApi,
} from '@/api/deploy'

import { 
    listSpaceApi, 
    listProjectApi 
} from '@/api/project'

import { 
    applySubmitApi, 
    applyRollbackListApi 
} from '@/api/deploy'

import {
    WorksListByFlowid,
    WorkflowDetailApi,
    WorkflowDeployAddApi,
    WorkflowCommandAddApi,
    WorkflowOneKeyAuditApi,
    WorkflowFinishApi,
} from '@/api/workflow'

export default {
    data() {
        return {
            sendDisabled: false,
            gridData:[],
            gridDataTotal:0,
            id:0,
            workflowDetail:{},
            tableData: [],
		    auditStatusList: [
                {status: this.$root.AuditStatusPending, label: this.$t('unaudit')},
                {status: this.$root.AuditStatusOk, label: this.$t('audit_pass')},
                {status: this.$root.AuditStatusRefuse, label: this.$t('audit_denied')},
            ],

            dialogCmdForm: {
                id: 0,
                name: '',
                description: '',
                tmode: 1,
                template_name:'',
                status: 0,
            },
            auditStatus:2,
            auditRefusalReason:"",            
			dialogTitle:'',
			dialogCmdVisible: false,
			dialogCmdEditVisible:false,
			dialogCmdLoading:'',
            dialogCmdApplyForm: '',
			dialogCmdDetail:{
                name: '',
                space_name: '',
                tmode: 1,
                template_name: '',
                flow_name: '',
                username: '',
                audit_status: 0,
                description: '',
                ctime: '',
                cmd: '',
                status: 1,
            },


            dialogDepVisible: false,
            dialogDepEditVisible:false,
			dialogDepLoading:'',
			dialogDepDetail:{},
            dialogDepForm: {
            	id: 0,
                branch_name: '',
                commit_version: '',
                description: '',
            },

            tableLoading: 'false',


            dialogCmdApplyVisible: false,
            dialogCmdApplyForm:{
            	id:0,
            	tmode:1,
            },
            templateList:[],

            dialogDepApplyVisible: false,
            dialogDepApplyForm: {},
            projectList: [],
            projectDetail: {
                deploy_mode:2,
            },
            rollbackList:[],
            dialogOnekeyAuditVisible: false,
            dialogFinishVisible:false,

        }
    },

    methods: {

        loadTableData() {
            this.tableLoading = true
            let query = {
                flowid : this.id,
            }
            WorksListByFlowid(query).then(res => {
                this.tableData = res.list
                this.$root.Total = res.total
                this.tableLoading = false
            }).catch(err => {
                this.tableLoading = false
            })
        },

        initPageLoader(){
            this.id = this.$route.query.id
            
        	WorkflowDetailApi({id: this.id}).then(res =>{
        		this.workflowDetail = res
        	}).catch(err =>{
        		this.tableLoading =false
        	})
        	this.loadTableData()
            this.loadButtonDisabled()
        },

    	flowHandler(cmd, row){
   
    		switch(cmd){
    			case 'view':
    			case 'audit':
    			    if (row.flow_type.typeid == 2){
    			        this.viewCmdHandler(cmd, row)
    			    }else {
    			    	this.viewDepHandler(cmd, row)
    			    } 				
    				break
    			case 'edit':
    			    if (row.flow_type.typeid == 2){
    				    this.editCmdHandler(cmd, row)
    				}else{
    				    this.editDepHandler(cmd, row)
    				}
    				break
    			case 'execute':
    				if (row.flow_type.typeid == 2){
    				    this.executeCmdHandler(cmd, row)
    				}else{
    				    this.deployHandler(cmd, row)
    				}
    				break
    			case 'drop':
    				if (row.flow_type.typeid == 2){
    				    this.dropCmdHandler(cmd, row)
    				}else{
    				    this.dropDepHandler(cmd, row)
    				}
    				break
    		}
    	},

		viewCmdHandler(cmd, row) {
            this.dialogCmdLoading = true
            OperateDetailApi({id: row.id}).then(detail => {
                this.dialogCmdLoading = false
                this.dialogCmdDetail = detail
                this.dialogCmdDetail.id = row.id
                this.dialogCmdDetail.email = row.email
                this.dialogCmdDetail.cmd = cmd
                this.openCmdDialogHandler(cmd == 'view' ? this.$t('view') : this.$t('audit'))
            }).catch(err => {
                this.dialogCmdLoading = false
            })
        },

        editCmdHandler(cmd, row){
            this.dialogLoading = true
        
            OperateDetailApi({id: row.id}).then(detail => {
                this.dialogLoading = false
                this.dialogCmdDetail = detail
                this.dialogCmdForm = {
                    id: row.id,
                    template_name: detail.template_name,
                    name: detail.name,
                    tmode: detail.tmode,
                    description:  detail.description,
                }
                this.openCmdEditDialogHandler(cmd == 'edit' ? this.$t('edit') : this.$t('audit'))
            }).catch(err => {
                this.dialogLoading = false
            })  
        },
        
        dropCmdHandler(cmd, row) {
            this.$root.ConfirmDelete(() => {
                OperateDropApi({id: row.id}).then(res => {
                    this.loadTableData()
                })
            }, this.$t('drop_deploy_apply_tips'))
        },

        executeCmdHandler(cmd, row) {
            this.$router.push({name: 'operateRelease', query: { id: row.id}})
        },

        openCmdDialogHandler(title) {
            this.dialogTitle = title + "命令单"
            this.dialogCmdVisible = true
        },
        
        openCmdEditDialogHandler(title){
            this.dialogTitle = title
            this.dialogCmdEditVisible = true
        },
        
        openCmdApllyDialogHandler(){
        	TemplateListApi({space_id: this.workflowDetail.space_id, offset: 0, limit : 999}).then(res => {
                if (res.list) {
                    this.templateList = res.list
                }
            })

        	this.dialogCmdApplyVisible = true
        },


        closeCmdDialogHandler(){
            this.dialogCmdVisible = false
        },

        closeCmdEditDialogHandler(){
            this.dialogCmdEditVisible = false
            this.dialogLoading = false
        },

        closeCmdApplyDialogHandler(){
        	this.dialogCmdApplyVisible = false
        	this.dialogLoading = false
        },

        dialogCmdApplySubmitHandler(){
        	this.$refs.dialogCmdRef.validate((valid)=>{
        		if(!valid){
        			return false;
        		}
        		this.btnLoading = true
        		let postData = {
        			id:this.dialogCmdApplyForm.id,
        			template_id:this.dialogCmdApplyForm.template_id,
        			name: this.dialogCmdApplyForm.name,
        			tmode: this.dialogCmdApplyForm.tmode,
        			space_id: this.workflowDetail.space_id,
        			description: this.dialogCmdApplyForm.description,
        		}
                WorkflowCommandAddApi(postData, this.id).then(res => {
                    this.$alert(this.$t('command_apply_submit_success'), this.$t('submit_success'), {
                        type: 'success',
                        confirmButtonText: this.$t('enter'),
                        callback: action => {
                            this.closeCmdApplyDialogHandler()
                            this.loadTableData()
                        }
                    })
                    this.btnLoading = false
                }).catch(err => {
                    this.btnLoading = false
                })
        	})
        },

        dialogCmdSubmitEditHandler() {
            this.$refs.dialogCmdEditRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.btnLoading = true
                let postData = {
                    id: this.dialogCmdForm.id,
                    description: this.dialogCmdForm.description,
                }
                OperateUpdateApi(postData).then(res => {
                    this.$alert(this.$t('update_success'), this.$t('submit_success'), {
                        type: 'success',
                        confirmButtonText: this.$t('enter'),
                        callback: action => {
                            this.closeCmdEditDialogHandler()
                        }
                    })
                    this.btnLoading = false
                }).catch(err => {
                    this.btnLoading = false
                })
            })
        },
        dialogCmdSubmitAuditStatusHandler(){

            this.btnLoading = true
            let postData = {
                id: this.dialogCmdDetail.id,
                audit_status: this.auditStatus,
                audit_refusal_reason: this.auditRefusalReason,
            }
            OperateAuditStatusUpdateApi(postData).then(res => {
                this.$alert(this.$t('audit_success'), this.$t('submit_success'), {
                    type: 'success',
                    confirmButtonText: this.$t('enter'),
                    callback: action => {
                        this.closeCmdDialogHandler()
                        this.loadTableData()
                    }
                })
                this.btnLoading = false
            }).catch(err => {
                this.btnLoading = false
            })  
        },
        
        auditCmdStatusTitle(auditStatus) {
            let auditTitle = ''
            this.auditStatusList.forEach(item => {
                if (auditStatus == item.status) {
                    auditTitle = item.label
                }
            })
            return auditTitle
        },


        dialogCmdCloseHandler() {
            this.dialogCmdVisible = false
            this.dialogLoading = false
            this.btnLoading = false
            this.$refs.dialogRef.resetFields();
            this.dialogForm = {}
        },
        currentCmdChangeHandler() {
            this.loadTableData()
        },



        //部署相关函数


        

        closeDepDialogHandler() {
            this.dialogDepVisible = false
        },
        openDepDialogHandler(title) {
            this.dialogTitle = title + "部署单" 
            this.dialogDepVisible = true
        },

        closeDepEditDialogHandler() {
            this.dialogDepEditVisible = false
        },
        openDepEditDialogHandler() {
            this.dialogDepEditVisible = true
        },

        loadProjectList(spaceId) {
            listProjectApi({space_id: spaceId, offset: 0, limit : 999}).then(res => {
                if (res.list) {
                    this.projectList = res.list
                }
            })
        },

        loadProjectDetail(){
        	applyProjectDetailApi({id: this.dialogDepApplyForm.project_id}).then(res => {
                this.projectDetail = res
                this.loadApplyRollbackList(res.id)
            })
            
        },
        loadApplyRollbackList(id){
            applyRollbackListApi({id: id}).then(res => {
                if (res) {
                    this.rollbackList = res
                }
            })
        },


        closeDepApplyDialogHandler() {
            this.dialogDepApplyVisible = false
        },
        openDepApplyDialogHandler() {
            //this.$refs.formRef.validate((valid) => {
            //    if (!valid) {
            //        return false;
            //    }
                
                this.loadProjectList(this.workflowDetail.space_id)
                this.dialogDepApplyVisible = true
                
                
            //})
        },
        dialogDepSubmitEditHandler() {
            this.$refs.dialogDepEditRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.dialogBtnLoading = true
                applyUpdateApi(this.dialogDepForm).then(res => {
                    this.$message({
                        message: this.$t('update_success'),
                        type: 'success',
                        duration: 1000,
                        onClose: () => {
                            this.closeDepEditDialogHandler()
                            this.loadTableData()
                            this.dialogBtnLoading = false
                        },
                    })
                }).catch(err => {
                    this.dialogBtnLoading = false
                })
            })
        },
        dialogDepSubmitAuditStatusHandler() {
            let postData = {
                id: this.dialogDepDetail.id,
                audit_status: this.auditStatus,
                audit_refusal_reasion: this.auditRefusalReason,
            }
            this.dialogBtnLoading = true
            applyAuditApi(postData).then(res => {
                this.$message({
                    message: this.$t('audit_success'),
                    type: 'success',
                    duration: 1000,
                    onClose: () => {
                        this.closeDepDialogHandler()
                        this.loadTableData()
                        this.dialogBtnLoading = false        
                        this.auditRefusalReason = ""
                        this.auditStatus = 2
                    },
                })
            }).catch(err => {
                this.dialogBtnLoading = false
            })
        },
        
        dialogDepApplySubmitHandler(){
            this.$refs.formDeployRef.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.btnLoading = true
                let postData = {
                    project_id: this.dialogDepApplyForm.project_id,
                    space_id: this.workflowDetail.space_id,
                    name: this.dialogDepApplyForm.name,
                    branch_name: this.dialogDepApplyForm.branch_name,
                    description: this.dialogDepApplyForm.description,
                    commit_version: this.dialogDepApplyForm.commit_version,
                    rollback_id: this.dialogDepApplyForm.rollback_id,
                }
                WorkflowDeployAddApi(postData, this.id).then(res => {
                    this.$alert(this.$t('deploy_apply_submit_success'), this.$t('submit_success'), {
                        type: 'success',
                        confirmButtonText: this.$t('enter'),
                        callback: action => {
                            this.closeDepApplyDialogHandler()
                            this.loadTableData()
                        }
                    })
                    this.btnLoading = false
                }).catch(err => {
                    this.btnLoading = false
                })
            })

        },

        deployHandler(cmd, row) {
            this.$router.push({name: 'deployRelease', query: { id: row.id}})
        },
        dropDepHandler(cmd, row) {
            this.$root.ConfirmDelete(() => {
                applyDropApi({id: row.id}).then(res => {
                    this.loadTableData()
                })
            }, this.$t('drop_deploy_apply_tips'))
        },
        editDepHandler(cmd, row) {
            this.dialogLoading = true
            this.getApplyDetail(cmd, row).then(detail => {
                this.dialogLoading = false
                this.dialogDepDetail = detail
                this.dialogDepForm = {
                    id: row.id,
                    branch_name: detail.branch_name,
                    commit_version: detail.commit_version,
                    description: detail.description,
                }
                this.openDepEditDialogHandler()
            }).catch(err => {
                this.dialogLoading = false
            })
        },
        viewDepHandler(cmd, row) {
            this.dialogLoading = true
            this.getApplyDetail(cmd, row).then(detail => {
                this.dialogLoading = false
                this.dialogDepDetail = detail
                this.openDepDialogHandler(cmd == 'view' ? this.$t('view') : this.$t('audit'))
            }).catch(err => {
                this.dialogLoading = false
            })
        },
        getApplyDetail(cmd, row) {
            let promise = new Promise((resolve, reject) => {
                let projDetailPromise = new Promise((resolve, reject) => {
                    applyProjectDetailApi({id: row.templateid}).then(res => {
                        resolve(res)
                    }).catch(err => {
                        reject(err)
                    })
                })
                let applyDetailPromise = new Promise((resolve, reject) => {
                    applyDetailApi({id: row.id}).then(res => {
                        resolve(res)
                    }).catch(err => {
                        reject(err)
                    })
                })
                Promise.all([projDetailPromise, applyDetailPromise]).then(res => {
                    let projDetail = res[0]
                    let applyDetail = res[1]
                    let dialogDepDetail = {
                        id: row.id,
                        space_name: this.workflowDetail.space_name,
                        project_name: row.template,
                        name: row.name,
                        deploy_mode: projDetail.deploy_mode,
                        repo_branch: projDetail.repo_branch,
                        branch_name: applyDetail.branch_name,
                        commit_version: applyDetail.commit_version,
                        description: applyDetail.description,
                        audit_status: row.audit_status,
                        email: row.email,
                        username: row.username,
                        ctime: row.ctime,
                        audit_status: applyDetail.audit_status,
                        status: applyDetail.status,
                        cmd: cmd,
                    }
                    resolve(dialogDepDetail)
                }).catch(err => {
                    reject(err)
                })
            })
            return promise
        },
        searchHandler() {
            this.$root.PageInit()
            this.loadTableData()
        },
        currentChangeHandler() {
            this.loadTableData()
        },
        auditStatusTitle(auditStatus) {
            let auditTitle = ''
            this.auditStatusList.forEach(item => {
                if (auditStatus == item.status) {
                    auditTitle = item.label
                }
            })
            return auditTitle
        },

        loadWorksTable(){
            WorksListByFlowid({flowid: this.id, audit_status: 1, status: 1}).then(res=>{
                this.gridData = res.list
                this.gridDataTotal = res.total
            }).catch(err=>{
                this.gridData = []
            })
        },

        openOnekeyAuditDialogHandler(){
            this.loadWorksTable()
            this.dialogOnekeyAuditVisible = true
        },
        closeOnekeyAuditDialogHandler(){
            this.dialogOnekeyAuditVisible = false
        },
        dialogOnekeyAuditSubmitHandler(){
        
            let postData = {
                id: this.id,
                audit_status: this.auditStatus,
                audit_refusal_reasion: this.auditRefusalReason,
                works: JSON.stringify(this.gridData),
            }
            WorkflowOneKeyAuditApi(postData).then(res => {
                this.$alert(this.$t('audit_success'), this.$t('submit_success'), {
                    type: 'success',
                    confirmButtonText: this.$t('enter'),
                    callback: action => {
                        this.closeOnekeyAuditDialogHandler()
                        this.loadTableData()
                    }
                })
                this.btnLoading = false
            }).catch(err => {
                this.btnLoading = false
            })            
        },
        

        finishWorkFlowSubmitHandler(){
            let postData = {
                id: this.id,
            }
            this.$confirm(this.$t('makesure_finish_detail'), this.$t('makesure_finish_workflow'), {
                confirmButtonText: this.$t('enter'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning',
                
            }).then(() => {
            
                WorkflowFinishApi(postData).then(res => {
                    this.$alert(this.$t('finished'), this.$t('finish_workflow'), {
                        type: 'success',
                        confirmButtonText: this.$t('enter'),
                        callback: action => {
                            this.initPageLoader()
                        }
                    })
                }).catch(err =>{
                    this.btnLoading = false
                })
            }).catch(action =>{
                this.$message({
                    type: 'info',
                    message: this.$t('cancel'),
                })
            })
            
        },

    },

    mounted() {
        this.initPageLoader()
    },
}

</script>






